<!-- src/components/DownloadCards.vue -->
<template>
  <div class="full-screen-background">
    <div class="download-section">
      <!-- Título centralizado -->
      <h2 class="text-center mb-6">{{ t('download.title') }}</h2>
  
      <div class="download-wrapper d-flex flex-column align-center">
        <v-card
          v-for="service in services"
          :key="service.name"
          class="download-card pa-4 mb-4"
        >
          <v-card-title class="d-flex align-center">
            <v-icon class="me-2" large>{{ service.icon }}</v-icon>
            <span class="text-h6">{{ service.label }}</span>
          </v-card-title>
  
          <v-card-actions class="justify-center mt-auto">
            <v-btn
              :href="service.url"
              target="_blank"
              color="red"
              dark
            >
              {{ t('download.btnDownload') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Substitua pelos seus links definitivos
const services = ref([
  {
    name: 'mediafire',
    label: 'MediaFire',
    icon: 'mdi-cloud-download-outline',
    url: 'https://www.mediafire.com/file/SEU_ARQUIVO'
  },
  {
    name: 'onedrive',
    label: 'OneDrive',
    icon: 'mdi-microsoft-onedrive',
    url: 'https://1drv.ms/SEU_ARQUIVO'
  }
])
</script>

<style scoped>
.download-section {
  width: 100%;
}

h2 {
  font-weight: 500;
}

.download-wrapper {
  width: 100%;
}

.download-card {
  width: 100%;
  max-width: 400px;
  /* borda clara */
  border: 1px solid rgba(0, 0, 0, 0.137);
  /* sombra pronunciada */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s;
  background-color: rgba(0, 0, 0, 0.747);
}

.download-card:hover {
  transform: translateY(-4px);
}

.full-screen-background {
  background-image: url('@/assets/background/cassino/cassinoz.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 100vh;
  width: 100%;
  position: relative;
}
</style>
